import { IntlShape } from 'react-intl';

import { FileUploaderValue } from '@xsolla/ui-uploader';

import { OldLoginWidgetStyleType } from '../../../api';
import { OauthSettings } from '../../../api/configurations/oauth2/types';

export type WidgetCustomizationState = {
  intl: IntlShape | null;
  fetching: boolean;
  submitting: boolean;
  isPreview: boolean;
  submitError: string;
  isAgreementSigned: boolean;
  widgetPreviewSettings: {
    countryOptions: Array<{ value: string; children: string }>;
    languageOptions: Array<{ value: string; children: string }>;
    country: string;
    language: string;
  };
  oauth2: {
    oauth2Options: Array<{ value: string; children: string }>;
    allOAuth2: OauthSettings[];
    oauth2Id: string;
    currOAuth2: OauthSettings | null;
  };
  visualSettings: {
    customStyleUrl: string;
    pristine: boolean;
  };
  oldLoginWidget: {
    widgetStyle: OldLoginWidgetStyleType | null;
    uploadStatus: FileStatus;
    uploadFileValue: FileUploaderValue;
  };
};

export enum FileStatus {
  IDLE_STATUS = 'idle',
  LOADING_STATUS = 'loading',
  ERROR_STATUS = 'error',
  SUCCESS_STATUS = 'success'
}

export enum ActionType {
  setFetching = 'setFetching',
  setCountryOptions = 'setCountryOptions',
  setLanguageOptions = 'setLanguageOptions',
  setOauth2Options = 'setOauth2Options',
  setCountry = 'setCountry',
  setLanguage = 'setLanguage',
  setOauth2Id = 'setOauth2Id',
  setCustomStyleUrl = 'setCustomStyleUrl',
  setOldWidgetStyle = 'setOldWidgetStyle',
  setOldWidgetFileStatus = 'setOldWidgetFileStatus',
  setOldWidgetFileValue = 'setOldWidgetFileValue',
  togglePreview = 'togglePreview',
  submitStarted = 'submitStarted',
  submitSuccess = 'submitSuccess',
  submitFailed = 'submitFailed'
}

export type Action =
  | {
      type: ActionType.setFetching;
      payload: boolean;
    }
  | { type: ActionType.setCountryOptions; payload: string[] }
  | { type: ActionType.setLanguageOptions; payload: string[] }
  | { type: ActionType.setOauth2Options; payload: OauthSettings[] }
  | { type: ActionType.setLanguage; payload: string }
  | { type: ActionType.setCountry; payload: string }
  | { type: ActionType.setOauth2Id; payload: string }
  | { type: ActionType.setCustomStyleUrl; payload: string }
  | { type: ActionType.setOldWidgetStyle; payload: OldLoginWidgetStyleType | null }
  | { type: ActionType.setOldWidgetFileStatus; payload: FileStatus }
  | { type: ActionType.setOldWidgetFileValue; payload: FileUploaderValue | null }
  | { type: ActionType.togglePreview }
  | { type: ActionType.submitStarted }
  | { type: ActionType.submitSuccess }
  | { type: ActionType.submitFailed; payload: string };
